export default "__VITE_ASSET__38664848__"